import { Component, input } from '@angular/core';

@Component({
  selector: 'rid-modal-background',
  imports: [],
  templateUrl: './rid-modal-background.html',
  host: {
    class: 'block absolute size-full pointer-events-none',
    'animate.enter': 'anim-fade-in',
    'animate.leave': 'anim-fade-out',
  },
})
export class RidModalBackground {
  blur = input<boolean>(false);
}
